<template>
  <transition name="fade">
    <div
      v-show="$store.state.show === 'page2'"
      :class="['page page2', $store.state.show === 'page2' ? 'active' : '']"
    >
      <div class="content">
        <div class="cont">
          <!-- <div :class="['screen screen1', $store.state.screen === 'screen3' ? 'active' : '' ? 'active' : '']">
            <img src="./images/p2-p1-diaoxiang.png" alt="" class="p1-diaoxiang abs" />
          </div>

          <div :class="['screen screen1-0', $store.state.screen === 'screen3' ? 'active' : '' ? 'active' : '']">
            <div class="p1-hand abs" @click="nextPage">
              <div class="p1-hand-w">
                <img src="./images/p2-p1-shou-dot.png" alt="" class="p1-shou-dot abs" />
                <img src="./images/p2-p1-shou.png" alt="" class="p1-shou abs" />
                <img src="./images/p2-p1-tips.png" alt="" class="p1-tips abs" />
              </div>
            </div>
          </div> -->

          <div :class="['screen screen2', $store.state.screen === 'screen4' ? 'active' : '' ? 'active' : '']">
            <img src="./images/p2-p2-diaoxiang.gif" alt="" class="p2-diaoxiang p2-diaoxiang1 abs" />
            <img src="./images/p2-p2-diaoxiang1.png" alt="" class="p2-diaoxiang p2-diaoxiang2 abs opacity" />
            <img src="./images/p2-p2-lubiao.png" alt="" class="p2-lubiao abs opacity" />
            <div class="p2-yanzi abs opacity">
              <div class="wrap">
                <img src="./images/p2-p2-yanzi.png" alt="" class="p2-yanzi1" />
                <img src="./images/p2-p2-yanzi1.png" alt="" class="p2-yanzi2" />
              </div>
            </div>
          </div>

          <div :class="['screen screen3', $store.state.screen === 'screen5' ? 'active' : '' ? 'active' : '']">
            <img src="./images/p2-p3-diaoxiang.gif" alt="" class="p3-diaoxiang1 abs" />
            <!-- <img src="./images/p2-p3-diaoxiang.png" alt="" class="p3-diaoxiang abs" /> -->
            <img src="./images/p2-p3-lubiao.png" alt="" class="p3-lubiao abs opacity" />
            <img src="./images/p2-p3-text.png" alt="" :class="['p3-text abs opacity', $store.state.showHand ? 'active' : '']" />
          </div>

          <!-- <div :class="['screen screen3-0', $store.state.showHand ? 'active' : '']"> -->
          <div :class="['screen screen3-0', $store.state.screen === 'screen5' ? 'active' : '' ? 'active' : '']">
            <div class="p1-hand abs" @click="nextPage2">
              <div class="p1-hand-w">
                <img src="./images/p2-p1-shou-dot.png" alt="" class="p1-shou-dot abs" />
                <img src="./images/p2-p1-shou.png" alt="" class="p1-shou abs" />
                <img src="./images/p2-p3-tips.png" alt="" class="p3-tips abs" />
              </div>
            </div>
          </div>

          <div :class="['screen screen4', $store.state.screen === 'screen6' ? 'active' : '' ? 'active' : '']">
            <div class="p4-juanzhou abs">
              <div class="p4-text-wrap">
                <!-- <div class="p4-title">平陆运河线路图</div> -->
                <img src="./images/p2-p4-ditu.png" alt="" class="p4-ditu abs" />
              </div>
              <img src="./images/p2-p4-close.png" @click="closeFn" alt="" class="p4-close abs" />
            </div>
          </div>

          <img src="./images/p2-p1-molihua.png" alt="" class="p1-molihua abs" />
        </div>

        <img src="./images/yun-zuo.png" alt="" class="yun-zuo abs" />
        <img src="./images/yun-you.png" alt="" class="yun-you abs" />
        <img :class="['tips-up abs ', $store.state.screen === 'screen4' || $store.state.screen === 'screen5' && $store.state.showHand && $store.state.clickMap ? '' : 'opacity']" src="./images/tips-up.png" alt="" />
      </div>
    </div>
  </transition>
</template>

<script>
import $ from "jquery";
import { setTimeout } from 'timers';
export default {
  name: "page2",
  components: {},
  data() {
    return {
      // showHand: false,
      // clickMap: false,
    };
  },
  // props: {
  //   music5: {
  //     type: Object,
  //     default: ()=>{}
  //   }
  // },
  methods: {
    // 下一页
    nextPage() {
      this.$store.dispatch("setScreenFn", "screen4");

      // window.music4.currentTime = 0;
      // setTimeout(() => {
      //   window.music4.play()
      // }, 200)
    },
    nextPage2() {
      this.$store.dispatch("setScreenFn", "screen6");
      // this.clickMap = true
      this.$store.dispatch("setShowHandFn", true);
    },
    closeFn() {
      const that = this
      that.$store.dispatch("setScreenFn", "screen5");
      window.playAll(window.music5)
      window.music5.addEventListener('ended', function () {
        that.$store.dispatch("setclickMapFn", true);
      }, false);
    },
  },
  mounted() {
  },
  watch: {
    "$store.state.screen" () {
      const that = this
      console.log(this.$store.state.screen)
      if (that.$store.state.screen === "screen4") {
        // that.music5 = new Audio(require('../components/media/2.mp3'))
        // that.music5.play()
        // window.music5.addEventListener('ended', function () {
          that.$store.dispatch("setShowHandFn", false);
          that.$store.dispatch("setclickMapFn", false);
        // }, false);
      } else {
        // that.$store.dispatch("setShowHandFn", false);
        // window.music5 && window.music5.pause()
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/mixin";

.page2 {
  background: url("./images/p2-p1-bg.jpg") top center no-repeat;
  background-size: 100% auto;

  .screen1-0.active,
  .screen3-0.active {
    .p1-shou-dot {
      -webkit-animation: identifier 0.6s linear infinite alternate;
      animation: identifier 0.6s linear infinite alternate;
    }

    .p1-shou {
      -webkit-animation: identifierhad 0.6s linear infinite alternate;
      animation: identifierhad 0.6s linear infinite alternate;
    }

    .p1-tips,
    .p3-tips {
      -webkit-animation: identifier 0.6s linear infinite alternate;
      animation: identifier 0.6s linear infinite alternate;
    }
  }

  .p2-yanzi {
    z-index: 10;
  }

  .screen2.active {
    .p2-yanzi {
      -webkit-animation: identifierx 1s ease-out;
      animation: identifierx 1s ease-out;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
    .p2-yanzi1 {
      -webkit-animation: identifierxy 0.6s ease-out 1.3s;
      animation: identifierxy 0.6s ease-out 1.3s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }

    .p2-diaoxiang2 {
      -webkit-animation: identifierxu 0.6s ease-out 2.3s;
      animation: identifierxu 0.6s ease-out 2.3s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }

    .p2-lubiao {
      -webkit-animation: identifiery 1s ease-out 0.2s;
      animation: identifiery 1s ease-out 0.2s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
  }

  .screen3.active {
    .p3-text.active {
      -webkit-animation: identifieryu 1s ease-out;
      animation: identifieryu 1s ease-out;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
    .p3-lubiao {
      -webkit-animation: identifieryu 1s ease-out 0.2s;
      animation: identifieryu 1s ease-out 0.2s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
  }

  .screen4.active {
    z-index: 50;

    .p4-juanzhou {
      height: 1049px;
    }
  }

  .content {
    .p1-diaoxiang {
      top: 581px;
      left: 147px;
      width: 517px;
    }

    .screen1-0.active {
      z-index: 50;
    }

    .screen3-0.active {
      z-index: 50;
    }

    .p1-hand {
      top: 920px;
      left: 347px;
      width: 60px;
      height: 60px;

      .p1-shou-dot {
        width: 49px;
      }

      .p1-shou {
        width: 81px;
        top: 18px;
        left: 8px;
      }

      .p1-tips {
        top: 130px;
        left: 65px;
        width: 166px;
      }

      .p3-tips {
        top: 135px;
        left: 0;
        width: 285px;
      }
    }
    .p1-molihua {
      width: 100%;
      bottom: 0;
      left: 0;
      z-index: 40;
    }

    .p2-diaoxiang {
      top: 444px;
      left: 420px;
      width: 293px;

      &.p2-diaoxiang1 {
        top: 444px;
        left: 0;
        width: 654px;
        z-index: 10;
      }
    }

    .p2-yanzi {
      top: 608px;
      right: 5px;
      width: 220px;
      height: 120px;
      .wrap {
        position: relative;
        width: 100%;
        height: 100%;

        .p2-yanzi1 {
          position: absolute;
          width: 144px;
          left: -20px;
          transition: all 0.5s ease-out 1.3s;
        }
        .p2-yanzi2 {
          position: absolute;
          top: 0;
          left: 50px;
          width: 169px;
          top: -57px;
        }
      }
    }

    .p2-lubiao {
      top: 117px;
      left: 443px;
      width: 102px;
    }

    .p3-diaoxiang {
      top: 563px;
      left: 107px;
      width: 544px;
    }

    .p3-diaoxiang1 {
      top: 463px;
      left: -257px;
      width: 1204px;
      z-index: 20;
    }

    .p3-text {
      top: 406px;
      left: 60px;
      width: 388px;
    }

    .p3-lubiao {
      top: 380px;
      right: 81px;
      width: 102px;
    }

    .p4-juanzhou {
      background: url("./images/p2-p4-juanzhou.png") top center no-repeat;
      background-size: 100% auto;
      width: 714px;
      // height: 1049px;
      top: 50px;
      @include cl();
      z-index: 11;
      height: 0;
      overflow: hidden;
      transition: height 1s ease-out 0.2s;

      .p4-text-wrap {
        width: 490px;
        margin: 0 auto;
        padding-top: 106px;
      }

      .p4-title {
        font-size: 54px;
        font-weight: bolder;
        color: #eb4500;
        text-align: center;
        padding-top: 30px;
        padding-bottom: 65px;
        line-height: 1.4;
      }
      .p4-ditu {
        top: 116px;
        width: 445px;
        @include cl();
      }
      .p4-close {
        top: 924px;
        width: 52px;
        @include cl();
      }
    }
  }
}
</style>
